import { useState, useEffect, useCallback } from "react";
import Footer from "../../components/shared/Footer";
import AttachFiles from "./components/AttachFiles";
import AttorneySelect from "../../components/shared/AttorneySelect";
import DFSSubmissionSummary from "./components/DFSSubmissionSummary";
import * as APIModels from "../../models";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import PartialCaseSearch from "./components/PartialCaseSearch";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../components/shared/modals/ErrorModal";

import { Spinner } from "react-bootstrap";
import { PlayCircleFilled } from "@material-ui/icons";

export default function DFSUpload() {
    const { id } = useParams<{ id: string }>();

    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.eFile | null
    );
    const [addExhibit, setAddExhibits] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const onEMClose = () => {
        setErrorProps({ errorMessage: "", onClose: onEMClose });
        setShowErrorModal(false);
    };

    const [errorProps, setErrorProps] = useState({
        errorMessage: "",
        onClose: onEMClose,
    } as ErrorModalProps);

    useEffect(() => {
        if (errorProps.errorMessage !== "") {
            console.log("show error modal:" + errorProps.errorMessage);
            setShowErrorModal(true);
        } else {
            setShowErrorModal(false);
        }
    }, [errorProps.errorMessage]);

    useEffect(() => {
        eFileService.get({ id: id }).then(
            (resp) => {
                setLoading(false);
                if (resp.successful && resp.data) {
                    //show efile success
                    seteFileUpload(resp.data);
                } else {
                    setErrorProps({
                        errorMessage: resp.errorMessage ?? "",
                        onClose: onEMClose,
                    });
                }
            },
            (error) => {
                setLoading(false);

                setErrorProps({
                    errorMessage: error.message,
                    onClose: onEMClose,
                });
            }
        );
    }, []);
    const [addAdditionalFiles, setAddAdditionalFiles] = useState(false);
    const [selectedCase, setSelectedCase] = useState(
        null as APIModels.Submission | null
    );

    const onAttorneySelected = (id: string, name: string) => {
        if (eFileUpload === null) {
            seteFileUpload({ attorneyID: id, attorneyName: name });
        } else {
            seteFileUpload({
                ...eFileUpload,
                attorneyID: id,
                attorneyName: name,
            });
        }
        console.log("NEWCASE ATTORNEYID " + id);
    };

    const onFirmSelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: "", attorneyName: "" });
        console.log(eFileUpload);
    };

    const onFinishedExhibits = (exhibits: APIModels.Exhibits) => {
        seteFileUpload({ ...eFileUpload, exhibits: exhibits });
    };

    const onClickAddAdditionalFiles = () => setAddAdditionalFiles(true);
    const onClickNoAdditionalFiles = () => setAddAdditionalFiles(false);

    const onSearchComplete = (result: APIModels.Submission) => {
        setSelectedCase(result);
        seteFileUpload({
            ...eFileUpload,
            serveWithSubmissionID: result.id,
            caseData: {
                county: result.caseData?.county,
                caseNumber:
                    result.caseData?.ucn ?? result.caseData?.courtCaseNumber,
                division: result.caseData?.division,
            },
        });
    };

    const onSubmit = () => {
        setSubmitLoading(true);
        SubmissionService.uploadService({
            id: id,
            body: eFileUpload!,
        })
            .then(
                (resp) => {
                    console.log(resp);
                    if (resp.successful && resp.data) {
                        //show efile success
                        window.location.href = "/uploads";
                    } else {
                        setErrorProps({
                            errorMessage: resp.errorMessage ?? "",
                            onClose: onEMClose,
                        });
                    }
                },
                (error) => {
                    setErrorProps({
                        errorMessage: error.message,
                        onClose: onEMClose,
                    });
                }
            )
            .then(() => setSubmitLoading(false));
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        DFS Submission
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {showErrorModal && <ErrorModal {...errorProps} />}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-10">
                                        <div
                                            id="checkout-nav-pills-wizard"
                                            className="twitter-bs-wizard form-wizard-header"
                                        >
                                            <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                <li className="nav-item">
                                                    <a
                                                        href="#attorney-info"
                                                        className="nav-link active"
                                                        style={{
                                                            pointerEvents:
                                                                "none",
                                                        }}
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            01
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Attorney
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        href="#case-info"
                                                        className="nav-link"
                                                        style={{
                                                            pointerEvents:
                                                                "none",
                                                        }}
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            02
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Case Information
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        href="#exhibit-info"
                                                        className="nav-link"
                                                        style={{
                                                            pointerEvents:
                                                                "none",
                                                        }}
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            03
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Additional Files
                                                            (Optional)
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        href="#summary"
                                                        className="nav-link"
                                                        style={{
                                                            pointerEvents:
                                                                "none",
                                                        }}
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            04
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Summary
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="attorney-info"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Attorney Information
                                                        </h4>
                                                        <p className="sub-header">
                                                            Please select the
                                                            attorney filing the
                                                            pleadings.
                                                        </p>
                                                    </div>
                                                    <AttorneySelect
                                                        onAttorneySelected={
                                                            onAttorneySelected
                                                        }
                                                        onFirmSelected={
                                                            onFirmSelected
                                                        }
                                                    />
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="list-inline-item">
                                                            <a
                                                                href="/uploads"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left"></i>{" "}
                                                                Back to Upload
                                                            </a>
                                                        </li>
                                                        <li className="next list-inline-item float-end">
                                                            {!eFileUpload?.attorneyID ||
                                                            eFileUpload?.attorneyID ==
                                                                "" ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success disabled"
                                                                    disabled
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="case-info"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Case Information
                                                        </h4>

                                                        <p className="sub-header">
                                                            Confirm the case you
                                                            are serving.
                                                        </p>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <PartialCaseSearch
                                                                sequenceDetected=""
                                                                searchingAttorneyId={
                                                                    eFileUpload?.attorneyID ??
                                                                    ""
                                                                }
                                                                onSearchComplete={() => {
                                                                    console.log(
                                                                        "search complete"
                                                                    );
                                                                }}
                                                                onCaseSelected={
                                                                    onSearchComplete
                                                                }
                                                            />
                                                        </div>
                                                        <div />
                                                    </div>
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="previous list-inline-item">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                Back to Attorney
                                                            </button>
                                                        </li>
                                                        <li className="next list-inline-item float-end">
                                                            {selectedCase ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success disabled"
                                                                    disabled
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="exhibit-info"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Additional Files
                                                        </h4>

                                                        <p className="sub-header">
                                                            Do you need to
                                                            attach additional
                                                            files to serve?
                                                        </p>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={
                                                                    onClickAddAdditionalFiles
                                                                }
                                                            >
                                                                Yes
                                                            </button>
                                                            &nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={
                                                                    onClickNoAdditionalFiles
                                                                }
                                                            >
                                                                No
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {addAdditionalFiles && (
                                                                <AttachFiles
                                                                    callback={
                                                                        onFinishedExhibits
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                        <div />
                                                    </div>
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="previous list-inline-item">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                Back to Case
                                                                Info
                                                            </button>
                                                        </li>
                                                        <li className="next list-inline-item float-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                            >
                                                                Next
                                                                <i className="mdi mdi-arrow-right"></i>{" "}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="summary"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Summary
                                                        </h4>
                                                        <p className="sub-header">
                                                            Review the
                                                            information below
                                                            and verify for
                                                            accuracy.
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {" "}
                                                        <DFSSubmissionSummary
                                                            upload={
                                                                eFileUpload ??
                                                                {}
                                                            }
                                                        />
                                                    </div>
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="previous list-inline-item">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                Back to Exhibits
                                                            </button>
                                                        </li>

                                                        <li className="next list-inline-item float-end">
                                                            <button
                                                                onClick={() =>
                                                                    onSubmit()
                                                                }
                                                                className="btn btn-success"
                                                            >
                                                                {submitLoading && (
                                                                    <>
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        />
                                                                        &nbsp;
                                                                        Loading...
                                                                    </>
                                                                )}
                                                                {!submitLoading && (
                                                                    <>
                                                                        <PlayCircleFilled />{" "}
                                                                        Submit
                                                                    </>
                                                                )}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
